export const API = {
    BASE_URL: window.REACT_APP_BASE,
    REACT_APP_SITE_KEY: window.REACT_APP_SITE_KEY
};
